module.exports = __webpack_public_path__ + "static/img/static/img/empty.686d3a87.png";